import { useMemo } from 'react'
import { Stack, Typography, ListItem, styled, Button } from '@mui/material'
import { getSessionInfo } from '../helper'
import { t } from '$i18n'

const StyledListItem = styled(ListItem)`
  height: 72px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
  padding: 13px 20px 14px;
`

interface SessionItemProps {
  userAgent?: string
  onClick?: () => unknown
}

export function SessionItem({ userAgent = '', onClick }: SessionItemProps) {
  // NOTE: `getSessionInfo` runs a full user-agent parse. The list re-renders on
  // every terminate, so without this the whole list is re-parsed each time.
  const { os, device } = useMemo(() => getSessionInfo(userAgent), [userAgent])
  const [primaryText, secondaryText] = [os, device].filter(Boolean)

  return (
    <StyledListItem>
      {primaryText ? (
        <Stack alignItems="flex-start" gap="4px">
          <Typography variant="subtitle3" color="neutral900">
            {primaryText}
          </Typography>

          {secondaryText && (
            <Typography variant="caption1" color="neutral600">
              {secondaryText}
            </Typography>
          )}
        </Stack>
      ) : (
        <Typography variant="subtitle3">
          {t('activeSessions.unknownInformation')}
        </Typography>
      )}

      <Button variant="text" color="error" onClick={onClick}>
        <Typography variant="subtitle3" color="inherit">
          {t('userActiveSessionsLimitModal.terminateSession')}
        </Typography>
      </Button>
    </StyledListItem>
  )
}
